import script from "./PSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./PSearch.vue?vue&type=script&lang=ts&setup=true"

import "./PSearch.vue?vue&type=style&index=0&id=4a71b42a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a71b42a"]])

export default __exports__